export enum EnumCorporateQueryKeys {
  CORPORATES_RECORD = 'CORPORATES_RECORD',
  CORPORATES_STATUS = 'CORPORATES_STATUS',
  CORPORATES_SEARCH = 'CORPORATES_SEARCH',
  CORPORATES_LIFECYCLE = 'CORPORATES_LIFECYCLE',
  CORPORATES_OFFER = 'CORPORATES_OFFER',
  CORPORATES_KYC_ACTIVITY_FORM_URL = 'CORPORATES_KYC_ACTIVITY_FORM_URL',
  CORPORATES_SUBBANKS_LIST = 'CORPORATES_SUBBANKS_LIST',
  CORPORATES_IDENTIFICATION_SESSION = 'CORPORATES_IDENTIFICATION_SESSION',
}
